<div class="subtitle">
  <label>Organizations</label>
</div>
<div class="work-area">
  <app-search-filter [config]="searchConfig" label="Orgs" mode="search"></app-search-filter>
  <app-paging [size]="size" [start]="start" [end]="max" [count]="count" [onNext]="Next.bind(this)"
    [onPrev]="Prev.bind(this)"></app-paging>
  <div class="org-list">
    <div *ngFor="let item of data" class="org-list-item" (click)="Select(item)">
      <span [innerHTML]="item.label"></span>
    </div>
  </div>
</div>
